import { z } from "zod";
import { DrillFiltersSchema, TableSchema } from ".";

export const ApiMakeBotActionSchema = z.object({
  tableId: z.string(),
  action: z.string(),
  botName: z.string(),
  amount: z.number().optional().nullable(),
});

export type ApiMakeBotAction = z.infer<typeof ApiMakeBotActionSchema>;

export const ApiPostPredefinedDrillListBodySchema = z.object({
  filters: DrillFiltersSchema.optional(),
});

export type ApiPostPredefinedDrillListBody = z.infer<
  typeof ApiPostPredefinedDrillListBodySchema
>;

export const ApiLoginQuerySchema = z.object({
  email: z.string().email(),
  tableId: z.string().optional(),
});

export const ApiVerifyCodeQuerySchema = z.object({
  email: z.string().email(),
  code: z.string().length(4),
});

export type ApiVerifyCodeQuery = z.infer<typeof ApiVerifyCodeQuerySchema>;

export type ApiLoginQuery = z.infer<typeof ApiLoginQuerySchema>;

export const ApiTableRemoveBotsSchema = z.array(TableSchema.shape.table_id);

export type ApiTableRemoveBots = z.infer<typeof ApiTableRemoveBotsSchema>;

export const ApiTableCreateSchema = z.object({
  tableConfig: TableSchema.pick({
    gaming_configuration: true,
    max_players: true,
    name: true,
    assessment_mode: true,
    preconfigured_mode: true,
  }),
  addBotsNumber: z.number().optional().nullable(),
  sitDownPlayer: z.boolean().optional().nullable(),
});
export type ApiTableCreate = z.infer<typeof ApiTableCreateSchema>;

export const ApiTableAddBotSchema = z.object({
  tableId: z.string(),
  seat: z.number().optional(),
  type: z.string(),
});

export type ApiTableAddBot = z.infer<typeof ApiTableAddBotSchema>;

export const ApiTableRemoveBotSchema = z.object({
  tableId: z.string(),
  botId: z.string(),
});

export type ApiTableRemoveBot = z.infer<typeof ApiTableRemoveBotSchema>;

export const ApiTableEditBotSchema = z.object({
  tableId: z.string(),
  botId: z.string(),
  stack: z.number(),
});

export type ApiTableEditBot = z.infer<typeof ApiTableEditBotSchema>;

export const ApiTableEditPlayerByPlayerSchema = z.object({
  type: z.literal("player"),
  tableId: z.string(),
  playerId: z.string(),
  avatarId: z.string().optional(),
});
export type ApiTableEditPlayerByPlayer = z.infer<
  typeof ApiTableEditPlayerByPlayerSchema
>;

export const ApiTableEditPlayerByHostSchema = z.object({
  type: z.literal("host"),
  tableId: z.string(),
  playerId: z.string(),
  stack: z.number(),
});
export type ApiTableEditPlayerByHost = z.infer<
  typeof ApiTableEditPlayerByHostSchema
>;

export const ApiTableEditPlayerSchema = z.discriminatedUnion("type", [
  ApiTableEditPlayerByPlayerSchema,
  ApiTableEditPlayerByHostSchema,
]);

export type ApiTableEditPlayer = z.infer<typeof ApiTableEditPlayerSchema>;

export const ApiTableTransferOwnershipSchema = z.object({
  tableId: z.string(),
  playerId: z.string(),
});
export type ApiTableTransferOwnership = z.infer<
  typeof ApiTableTransferOwnershipSchema
>;
